import axios from "axios";
import { myMSALObj, loginRequest } from '@/authConfig'
import { withRetry } from '@/utils/NetworkRetry';

const API = axios.create({
  // DATOS DEV --> DESCOMENTAR PARA DESARROLLAR Y COMENTAR "DATOS PRE" y "DATOS PRO"
  // baseURL: "https://localhost:7176/api/",

  // DATOS PRE --> DESCOMENTAR PARA PRE Y COMENTAR "DATOS DEV" y "DATOS PRO"
  // baseURL: "https://cpqpre.henryschein.es:444/api/",
  // DATOS PRO --> DESCOMENTAR PARA PRO Y COMENTAR "DATOS DEV" y "DATOS PRE"
  baseURL: "https://cpq.henryschein.es:444/api/", 
});

API.interceptors.request.use(async (config) => {
  try {
    let account = myMSALObj.getActiveAccount();
    if (!account) {
      const accounts = myMSALObj.getAllAccounts();
      if (accounts.length > 0) {
        account = accounts[0];
        myMSALObj.setActiveAccount(account);
      }
    }

    const tokenResponse = await withRetry(() =>
      myMSALObj.acquireTokenSilent({
        scopes: ['user.read'],
        account: account || undefined
      })
    );

    if (config.headers != null) {
      config.headers["Authorization"] = `Bearer ${tokenResponse.idToken}`;
      // DATOS DEV --> DESCOMENTAR PARA DESARROLLAR Y COMENTAR "DATOS PRE" y "DATOS PRO"
      // config.headers['Access-Control-Allow-Origin'] = 'http://localhost:8080/';

      // DATOS PRE --> DESCOMENTAR PARA PRE Y COMENTAR "DATOS DEV" y "DATOS PRO"
      // config.headers['Access-Control-Allow-Origin'] = 'https://cpqpre.henryschein.es/';

      // DATOS PRO --> DESCOMENTAR PARA PRO Y COMENTAR "DATOS DEV" y "DATOS PRE"
      config.headers['Access-Control-Allow-Origin'] = 'https://cpq.henryschein.es/'; 

      config.headers['Access-Control-Allow-Credentials'] = 'true';
      delete config.headers['Content-Type'];
      config.headers['Accept'] = 'application/json';
    }
    return config;
  } catch (error: any) {
    console.warn("Silent token acquisition failed completely in API interceptor.", error);

    // Si la interacción es estrictamente necesaria o no hemos podido renovar el token tras reintentar
    if (window.location.pathname !== '/login' && window.location.pathname !== '/Login') {
      window.location.href = '/login';
    }
    // Cancelar la petición original, ya que no tiene sentido continuar sin token válido
    return Promise.reject(error);
  }
}, (error) => {
  return Promise.reject(error);
});

API.interceptors.response.use(
  (response) => response,
  async (error: any) => {
    const originalRequest = error.config;
    // Si es 401 y no hemos reintentado ya esta petición
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      console.warn("401 Unauthorized detected. Attempting to restore session silently and retry request...");
      try {
        let account = myMSALObj.getActiveAccount();
        if (!account) {
          const accounts = myMSALObj.getAllAccounts();
          if (accounts.length > 0) {
            account = accounts[0];
            myMSALObj.setActiveAccount(account);
          }
        }

        await withRetry(() =>
          myMSALObj.ssoSilent({
            scopes: ['user.read'],
            loginHint: account?.username
          })
        );

        // Tras ssoSilent obtenemos el token
        const tokenResponse = await myMSALObj.acquireTokenSilent({
          scopes: ['user.read'],
          account: account || undefined
        });

        if (originalRequest.headers != null) {
          originalRequest.headers["Authorization"] = `Bearer ${tokenResponse.idToken}`;
        }

        // ¡Reintentamos la petición fallida!
        return API(originalRequest);
      } catch (silentError: any) {
        console.error("Silent session restoration failed.", silentError);

        if (window.location.pathname !== '/login' && window.location.pathname !== '/Login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default API;
